export default "__VITE_ASSET__CoOgk9hZ__"